// Scoreboard Podcast Takeover Configuration
// This takeover runs for 7 days with daily themed grids featuring different players

export const scoreboardTakeover = {
  startDate: "2026-05-21",
  endDate: "2026-05-27",

  days: [
    {
      date: "2026-05-21",
      episodeNumber: 135,
      guestName: "Jack Riewoldt",
      podcastEpisodeUrl:
        "https://open.spotify.com/episode/6zJWXfw8p9iVlPyguWIuZ3?si=nPDsjh-HRbibFB4WS4q0wg",
      description:
        "Richmond legend Jack Riewoldt joins Chris Titley for an open and grounded conversation about life beyond the AFL — parenting, purpose, the leadership lessons that fuelled Richmond's 2017 turnaround, and a 'scoreboard moment' with his dad.",
      backgroundImage: "/img/partners/scoreboard/thumbs/riewoldt.jpg",
    },
    {
      date: "2026-05-22",
      episodeNumber: 155,
      guestName: "Brandon Starcevich",
      podcastEpisodeUrl:
        "https://open.spotify.com/episode/7kmNZOCWvJ3ZETXBVVMRmw?si=-_RVhdnnSL-OJGbzKl1QQw",
      description:
        "Brandon Starcevich joins Chris Titley to unpack premiership success, free agency pressure and the mindset behind performing on the biggest stage.\n\nFrom breathing and visualisation to resilience and preparation, this is a raw insight into elite AFL mentality.",
      backgroundImage: "/img/partners/scoreboard/thumbs/starcevich.jpg",
    },
    {
      date: "2026-05-23",
      episodeNumber: 8,
      guestName: "Dale Morris",
      podcastEpisodeUrl:
        "https://open.spotify.com/episode/2xy2URjXJENnMQq99YfkAV?si=6tJyzGUBRdyeKTAf9NmB8w",
      description:
        "Dale Morris joins Chris Titley to reflect on rejection, redemption and the mindset behind overcoming setbacks to reach the biggest stage.\n\nFrom mailing VHS tapes to clubs to becoming a Bulldogs premiership hero, this is a raw insight into resilience, preparation and elite AFL mentality.",
      backgroundImage: "/img/partners/scoreboard/thumbs/morris.webp",
    },
    {
      date: "2026-05-24",
      episodeNumber: 86,
      guestName: "Simon Black",
      podcastEpisodeUrl:
        "https://open.spotify.com/episode/6cD3PaYaG1AfwSnnfoRSbQ?si=t5Ys-e7lTO2yg0j3vOu4jQ",
      description:
        "Simon Black joins Chris Titley to reflect on consistency, resilience and the mindset behind performing on the biggest stage.\n\nFrom overcoming Shulman’s disease to visualising every play before grand finals, this is a raw insight into preparation, discipline and elite AFL mentality.",
      backgroundImage: "/img/partners/scoreboard/thumbs/black.jpg",
    },
    {
      date: "2026-05-25",
      episodeNumber: 27,
      guestName: "Hayden McLean",
      podcastEpisodeUrl:
        "https://open.spotify.com/episode/7EGSV5VVriUPBBBMG1WT9q?si=QLDZz9NTSr-bexy1t8wM-w",
      description:
        "Hayden McLean joins Chris Titley on resilience, opportunity and the mindset behind carving out an AFL career at the highest level.\n\nFrom life outside the system to becoming a key forward for the Sydney Swans, this is a raw insight into persistence, preparation and elite AFL mentality",
      backgroundImage: "/img/partners/scoreboard/thumbs/mclean.webp",
    },
    {
      date: "2026-05-26",
      episodeNumber: 163,
      guestName: "Zach Tuohy",
      podcastEpisodeUrl:
        "https://open.spotify.com/episode/1es3fIgq6NdkMFTCwft7M8?si=VhQZsPOqRti1evMgj_Be8g",
      description:
        "Zach Tuohy joins Chris Titley to unpack confidence, culture and the mindset behind building one of the AFL’s most unique careers.\n\nFrom Ireland to becoming the most capped Irish player in AFL history, this is a raw insight into resilience, reinvention and elite AFL mentality.",
      backgroundImage: "/img/partners/scoreboard/thumbs/tuohy.webp",
    },
    {
      date: "2026-05-27",
      episodeNumber: 140,
      guestName: "Darcy Gardiner",
      podcastEpisodeUrl:
        "https://open.spotify.com/episode/7mwHDCinRsRcgvpNek9Cit?si=5U-XCmgMTAqXAJFFApKCVA",
      description:
        "Brisbane Lions premiership defender Darcy Gardiner joins Chris Titley to reflect on patience, leadership and the mindset behind Brisbane’s rise across 2024 and 2025.\n\nFrom personal evolution to turning the pain of 2023 into premiership redemption, this is a raw insight into resilience, preparation and elite AFL mentality.",
      backgroundImage: "/img/partners/scoreboard/thumbs/gardiner.jpg",
    },
  ],
};

// Helper function to check if takeover is currently active
export function isTakeoverActive(currentDate) {
  const current = new Date(currentDate);
  const start = new Date(scoreboardTakeover.startDate);
  const end = new Date(scoreboardTakeover.endDate);

  // Set to midnight for accurate date comparison
  current.setHours(0, 0, 0, 0);
  start.setHours(0, 0, 0, 0);
  end.setHours(0, 0, 0, 0);

  return current >= start && current <= end;
}

// Helper function to get the daily configuration for a specific date
export function getDailyConfig(dateKey) {
  return scoreboardTakeover.days.find((day) => day.date === dateKey);
}
